import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Container,
  Dialog,
  IconButton,
  Paper,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  selectClasses,
  Box,
  Grid
} from '@mui/material';
import { FormProvider, SelectTag, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { useCallback, useEffect, useState, useMemo } from 'react';
import { dropdownFetch, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { BASE_URL } from '../../../../../utils';

const styles = {
  select: {
    width: '60%',
    paddingTop: '5px',
    paddingBottom: '5px'
  },
  table: {
    width: '100%'
  }
};

export const Permission = () => {
  const [roles, setRoles] = useState([]);
  const [tabledata, setTabledata] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState({
    role: '',
    parent: '',
    child: '',
    grandChild: ''
  });
  const [isChecked, setIsChecked] = useState(false);

  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [render, setRender] = useState(false);
  const organizationData = useSelector((state) => state.organization);
  const data = useMemo(() => {
    return organizationData.find((item) => item.id === 'hospital')?.options || [];
  }, [organizationData]);

  const dataa = useMemo(() => {
    const selectedData = data.find((item) => item.id === selectedRoles.parent);
    if (!selectedData || selectedData.menu.lengTableCell === 0) {
      return [];
    }
    return selectedData.menu;
  }, [data, selectedRoles.parent]);

  const dataaa = useMemo(() => {
    const selectedDataa = dataa.find((item) => item.id === selectedRoles.child);
    if (!selectedDataa || selectedDataa.children.lengTableCell === 0) {
      return [];
    }
    if (selectedDataa.children) {
      let hasSubmenuChildren = false;

      selectedDataa.children.forEach((submenu) => {
        if (submenu.children) {
          hasSubmenuChildren = true;
        }
      });

      if (hasSubmenuChildren) {
        setRender(true);
      } else {
        setTabledata(selectedDataa.children);
      }
    }
    return selectedDataa.children;
  }, [dataa, selectedRoles.child]);

  const dataaaa = useMemo(() => {
    const selectedDataaa = dataaa.find((item) => item.id === selectedRoles.grandChild);

    if (!selectedDataaa) {
      return [];
    }

    if (!selectedDataaa.children) {
      return [selectedDataaa];
    }

    return selectedDataaa.children;
  }, [selectedRoles.grandChild]);

  useEffect(() => {
    if (dataaaa.length > 0) {
      setTabledata(dataaaa);
    }
  }, [dataaaa]);

  const extractIds = (organizationStore) => {
    return organizationStore ? organizationStore.map((item) => item.id) : [];
  };

  useEffect(() => {
    const fetchRolesData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/role/dropdown`);
        setRoles(response.data.data);
      } catch (error) {
        setError('Error fetching roles');
        console.error('Error fetching roles:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRolesData();
  }, []);
  useEffect(() => {
    if (permissions['DatePermission']) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  }, [permissions]);

  const handleRoleChange = (roleType) => async (e) => {
    const roleId = e.target.value;
    setSelectedRoles((prev) => ({ ...prev, [roleType]: roleId }));
    if (roleType === 'role' && roleId) {
      try {
        const response = await axios.get(`${BASE_URL}/role-master/${roleId}`);
        const rolePermissions = response.data.permissions.reduce((acc, perm) => {
          acc[perm] = true;
          return acc;
        }, {});
        setPermissions(rolePermissions);
      } catch (error) {
        console.error('Error fetching role permissions:', error);
      }
    }
    if (roleType === 'parent') {
      setSelectedRoles((prev) => ({ ...prev, child: '', grandChild: '' }));
      setRender(false);
      setTabledata([]);
    }
    if (roleType === 'child') {
      setSelectedRoles((prev) => ({ ...prev, grandChild: '' }));
      setRender(false);
      setTabledata([]);
    }
  };
  const handleCheckboxChangeDate = (event) => {
    setIsChecked(event.target.checked);
  };
  console.log(isChecked);
  const handleCheckboxChange = (action, permissionType) => {
    const permissionKey = `${selectedRoles.parent}-${selectedRoles.child}-${selectedRoles.grandChild}-${action}${permissionType.charAt(0).toUpperCase() + permissionType.slice(1)}`;
    setPermissions((prevPermissions) => ({
      ...prevPermissions,
      [permissionKey]: !prevPermissions[permissionKey]
    }));
  };

  const handleReset = () => {
    setSelectedRoles({
      role: '',
      parent: '',
      child: '',
      grandChild: ''
    });
    setRender(false);
    setTabledata([]);
    setPermissions({});
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedRoles.role) {
      alert('Please select a role.');
      return;
    }
    const selectedPermissions = Object.keys(permissions).filter((key) => permissions[key]);
    let result = [...selectedPermissions];
    const additionalPermissions = ['Exit', 'Submit', 'Cancel', 'hospital', 'lab', 'pharmacy', 'group'];
    additionalPermissions.forEach((permission) => {
      if (!result.includes(permission)) {
        result.push(permission);
      }
    });
    if (isChecked) {
      result.push('DatePermission');
    } else {
      result = result.filter((permission) => permission !== 'DatePermission');
    }
    try {
      await axios.put(`${BASE_URL}/role-master/update/${selectedRoles.role}`, { permissions: result });
      alert('Permissions updated successfully.');
      handleReset();
    } catch (error) {
      console.error('Error updating permissions:', error);
    }
  };

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider onSubmit={handleSubmit}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{ pb: 0.5, mb: 3, borderBottom: '1px solid', borderColor: 'grey.300' }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Permission
              </Typography>
            </Stack>
            <Stack spacing={2}>
              <Box
                sx={{
                  border: '0px solid gray',
                  padding: 2,
                  borderRadius: '8px',
                  width: '80%',
                  boxShadow: '0px 2px 10px #0099ff'
                }}
              >
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>Select Role</Typography>
                  <select
                    id="role"
                    value={selectedRoles.role}
                    onChange={handleRoleChange('role')}
                    style={{ ...styles.select, width: '60%', marginLeft: '4%' }}
                  >
                    <option value="" style={styles.option}>
                      Select Role
                    </option>
                    {roles.map((role) => (
                      <option key={role._id} value={role._id} style={styles.option}>
                        {role.role}
                      </option>
                    ))}
                  </select>
                  <Button type=" submit" variant="contained">
                    Submit
                  </Button>
                </Stack>

                <Stack direction="row" spacing={2} alignItems="center">
                  <Typography sx={{ flex: 0.51, fontSize: '1.4rem', fontWeight: 700 }}>Select Parent</Typography>
                  <select
                    id="parent"
                    value={selectedRoles.parent}
                    onChange={handleRoleChange('parent')}
                    style={{ ...styles.select, width: '60%', marginLeft: '1%' }}
                  >
                    <option value="" style={styles.option}>
                      Select Parent
                    </option>
                    {extractIds(data).map((role) => (
                      <option key={role} value={role} style={styles.option}>
                        {role}
                      </option>
                    ))}
                  </select>
                  <Typography sx={{ flex: 0.3, fontSize: '1.4rem', fontWeight: 700 }}>DatePermission</Typography>
                  <input type="checkbox" checked={isChecked} onChange={handleCheckboxChangeDate} />
                </Stack>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Typography sx={{ flex: 0.456, fontSize: '1.4rem', fontWeight: 700 }}>Select Child</Typography>
                  <select
                    id="child"
                    value={selectedRoles.child}
                    onChange={handleRoleChange('child')}
                    style={{ ...styles.select }}
                  >
                    <option value="" style={styles.option}>
                      Select Child
                    </option>
                    {extractIds(dataa).map((role) => (
                      <option key={role} value={role} style={styles.option}>
                        {role}
                      </option>
                    ))}
                  </select>
                </Stack>
                {selectedRoles.child && render && (
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Typography sx={{ flex: 0.4, fontSize: '1.4rem', fontWeight: 700 }}>Select Grand Child</Typography>
                    <select
                      id="grandChild"
                      value={selectedRoles.grandChild}
                      onChange={handleRoleChange('grandChild')}
                      style={styles.select}
                    >
                      <option value="" style={styles.option}>
                        Select Grand Child
                      </option>

                      {extractIds(dataaa).map((role) => (
                        <option key={role} value={role} style={styles.option}>
                          {role}
                        </option>
                      ))}
                    </select>
                  </Stack>
                )}
                <TableContainer component={Paper} style={styles.table}>
                  <Table style={styles.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>Label</TableCell>
                        <TableCell style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>Read</TableCell>
                        <TableCell style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>Write</TableCell>
                        <TableCell style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>Update</TableCell>
                        <TableCell style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>Print</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {extractIds(tabledata).map((action) => (
                        <TableRow key={action}>
                          <TableCell style={{ fontSize: '1rem', fontWeight: 'bold' }}>{action.toUpperCase()}</TableCell>
                          <TableCell>
                            <input
                              type="checkbox"
                              checked={
                                permissions[
                                  `${selectedRoles.parent}-${selectedRoles.child}-${selectedRoles.grandChild}-${action}Read`
                                ] || false
                              }
                              onChange={() => handleCheckboxChange(action, 'read')}
                            />
                          </TableCell>
                          <TableCell>
                            <input
                              type="checkbox"
                              checked={
                                permissions[
                                  `${selectedRoles.parent}-${selectedRoles.child}-${selectedRoles.grandChild}-${action}Write`
                                ] || false
                              }
                              onChange={() => handleCheckboxChange(action, 'write')}
                            />
                          </TableCell>
                          <TableCell>
                            <input
                              type="checkbox"
                              checked={
                                permissions[
                                  `${selectedRoles.parent}-${selectedRoles.child}-${selectedRoles.grandChild}-${action}Update`
                                ] || false
                              }
                              onChange={() => handleCheckboxChange(action, 'update')}
                            />
                          </TableCell>
                          <TableCell>
                            <input
                              type="checkbox"
                              checked={
                                permissions[
                                  `${selectedRoles.parent}-${selectedRoles.child}-${selectedRoles.grandChild}-${action}Print`
                                ] || false
                              }
                              onChange={() => handleCheckboxChange(action, 'print')}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Stack>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
